import { startOfDay } from 'date-fns';

// The local-day bucket: the epoch-ms of the start of `now`'s local day. The
// compute cache keys on it and the boundary timer re-derives the schedule when
// it changes. Both must agree.
export const localDayBucket = (now: Date): number => startOfDay(now).getTime();
